// Close the desktop nav's sub-navigation popovers when keyboard focus leaves
// them. Native popovers already close on Esc and on clicks outside, but not on
// focus moving elsewhere, so tabbing past the last link would leave it open.
// https://adrianroselli.com/2026/07/link-popover-navigation.html
//
// Delegated from document because Angular renders the nav after page load.
document.addEventListener('focusout', function(e) {
  var target = e.target;
  if (!(target instanceof Element)) return;

  // The top-level <li> holds the link, its trigger button and the popover.
  // Focus can leave from any of them (e.g. Shift+Tab off the link), so stay
  // open only while focus moves somewhere within that <li>.
  var item = target.closest('.nav-corporate > ul > li');
  if (!item) return;

  var popover = item.querySelector(':scope > .nav-corporate__popover');
  if (!popover || !popover.matches(':popover-open')) return;

  if (!item.contains(e.relatedTarget)) {
    popover.hidePopover();
  }
});
